module.exports = __webpack_public_path__ + "img/banner2.fcdecf57.jpg";